(() => {
  const container = document.querySelector('header-container[data-loew-area]');
  if (!container) return;
  const areas = ['damen', 'herren', 'kids', 'pferd'];
  let stored = '';
  try { stored = sessionStorage.getItem('loew-shopping-area') || ''; } catch {}
  const area = container.dataset.loewExplicitArea || (areas.includes(stored) ? stored : container.dataset.loewArea);
  if (area !== container.dataset.loewArea) {
    const desktop = document.querySelector(`template[data-loew-desktop-menu="${area}"]`);
    const drawer = document.querySelector(`template[data-loew-drawer-menu="${area}"]`);
    const desktopMenu = container.querySelector('.js-primary-nav');
    const drawerMenu = document.querySelector('#modal-main-menu drawer-menu');
    if (desktop && drawer && desktopMenu && drawerMenu) {
      desktopMenu.replaceWith(desktop.content.cloneNode(true));
      drawerMenu.replaceWith(drawer.content.cloneNode(true));
      container.dataset.loewArea = area;
    }
  }
  container.querySelectorAll('.loew-audience-tabs a').forEach((link) => {
    if (link.dataset.loewArea === container.dataset.loewArea) link.setAttribute('aria-current', 'true');
    else link.removeAttribute('aria-current');
    link.addEventListener('click', () => {
      try { sessionStorage.setItem('loew-shopping-area', link.dataset.loewArea); } catch {}
    });
  });
  try { sessionStorage.setItem('loew-shopping-area', container.dataset.loewArea); } catch {}
})();


if (!customElements.get('loew-collection-navigation')) {
  customElements.define('loew-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      const header = document.querySelector('header-container[data-loew-area]');
      const area = this.dataset.area || header?.dataset.loewArea || 'damen';
      this.querySelectorAll('[data-navigation-panel]').forEach(panel => {
        panel.hidden = panel.dataset.navigationPanel !== area;
      });
      this.querySelectorAll('[data-navigation-area]').forEach(link => {
        if (link.dataset.navigationArea === area) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
        link.addEventListener('click', () => {
          try { sessionStorage.setItem('loew-shopping-area', link.dataset.navigationArea); } catch {}
        });
      });
    }
  });
}
